export default "__VITE_ASSET__C0f5q5EO__"